import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import { Columns, GridTableComponent } from '@components/grid-table.component';
import { HelperService } from '@core/helper/helper.service';
import { Pagination, filterKeys } from '@core/interface/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { DocumentType } from '@core/interface/employee';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  AddDocumentPayload,
  DocumentItem,
} from '@core/interface/employee-document';
import { AddDocumentComponent } from './add-document/add-document.component';
import { DocumentTypeItem } from '@core/interface/document-type';
import { DocumentActions } from '@/store/employee/document/document.actions';
import { getDeletedStatus } from '@/store/employee/document/document.selectors';
import { LoaderService } from '@core/services/loader.service';
import { EmployeeService } from '@core/services/employee.service';
import { SimplebarAngularModule } from 'simplebar-angular';
import { environment } from '@environment/environment';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-document',
  imports: [
    TranslatePipe,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbPaginationModule,
    GridTableComponent,
    SimplebarAngularModule,
  ],
  templateUrl: './document.component.html',
  styles: ``,
  providers: [DatePipe],
})
export class DocumentComponent implements OnChanges {
  private modalService = inject(NgbModal);
  private helperService = inject(HelperService);
  private translateService = inject(TranslateService);
  private loaderService = inject(LoaderService);
  private employeeService = inject(EmployeeService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private datepipe = inject(DatePipe);
  public activeModal = inject(NgbActiveModal);
  private store = inject(Store);
  documents: DocumentItem[] = [];
  documents$: Subject<DocumentItem[]> = new Subject<DocumentItem[]>();
  @Input() records: DocumentItem[] = [];
  searchText: string = '';
  isLoading: boolean = false;
  filters: filterKeys = {};
  @Input() documentTypes: DocumentTypeItem[] = [];
  isViewMode: boolean = false;
  modalMaxHeight = innerHeight / 2 - 100;
  columns: Columns[] = [
    {
      name: 'Document Name',
      field: 'file_name',
      sortable: true,
      class: 'px-3',
      searchable: true,
    },
    {
      name: 'Category',
      field: 'document_type_name',
      sortable: true,
      searchable: true,
    },
    {
      name: 'Type',
      field: 'file_extension',
      sortable: true,
      searchable: true,
    },
    {
      name: 'Creation Date & Time',
      field: 'created_date_str',
      sortable: true,
      searchable: true,
    },
    {
      name: 'Expiry Date',
      field: 'expiry_date_str',
      sortable: true,
      searchable: true,
    },
    { name: 'Action', field: '', class: 'text-center' },
  ];
  subscription: Subscription = new Subscription();
  @Input() userId!: number | undefined;
  @Input() updatedDocuments: AddDocumentPayload[] = [];
  @Output() documentsChange = new EventEmitter<AddDocumentPayload[]>();
  @Output() documentUpdated = new EventEmitter<boolean>();
  ngOnChanges(changes: SimpleChanges): void {
    this.documents = [...this.records];
    if (
      changes['updatedDocuments'] &&
      changes['updatedDocuments'].currentValue &&
      changes['updatedDocuments'].currentValue.length
    ) {
      const documents = this.convertPayloadintoDocumentItem([
        ...this.updatedDocuments,
      ]);
      this.records = [...documents];
      this.documents = [...documents];
    }
  }
  ngOnInit(): void {
    this.showToaster();
    if (this.isViewMode) {
      this.isLoading = true;
      this.subscription.add(
        this.documents$.subscribe((data) => {
          this.documents = data;
          this.isLoading = false;
        })
      );
    }
  }

  /**
   *
   * @param document Document item if Updating the it.
   * Open the add Document modal and save data to add or update
   */
  async addEditDocument(document?: DocumentType) {
    const modalRef = this.modalService.open(AddDocumentComponent, {
      centered: true,
    });
    modalRef.componentInstance.document = document;
    modalRef.componentInstance.userId = this.userId;
    modalRef.componentInstance.documentTypes = this.documentTypes;
    try {
      const result = await modalRef.result;
      if (result) {
        if (result.id !== '') this.editDocument(result);
        else this.addDocument(result);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  /**
   * Search the text from the document array
   */
  searchfilter() {
    this.store.dispatch(
      DocumentActions.loadDocuments({
        search: this.searchText,
        user_id: this.userId!,
      })
    );
  }

  /**
   *
   * @param data sorted array
   * Sorts the comoany list based on selected field
   */
  onCompleteSort(data: DocumentType[]) {
    // this.companies = data;
  }

  /**
   *
   * @param param Compnay Item which needs to be deleted
   * Displays a delete confirmation dialod and
   * On confirmation deletes
   */
  deleteConfirm({ id }: DocumentType, index: number) {
    Swal.fire({
      title: this.translateService.instant('Are you sure'),
      text: this.translateService.instant("You won't be able to revert this"),
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-primary me-2 mt-2',
        cancelButton: 'btn btn-danger mt-2',
      },
      confirmButtonText: this.translateService.instant('Yes, Delete it'),
      buttonsStyling: false,
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        if (this.userId && id) {
          this.documentUpdated.emit(true);
          this.store.dispatch(DocumentActions.deleteDocument({ id }));
        } else {
          const toDelete = this.documents.splice(index, 1);
          if (toDelete.length) {
            if (
              toDelete[0].flatDocumentIndex !== undefined &&
              toDelete[0].flatDocumentIndex > -1
            ) {
              if (
                this.updatedDocuments[toDelete[0].flatDocumentIndex].attachments
                  .length > 1
              ) {
                this.updatedDocuments[
                  toDelete[0].flatDocumentIndex
                ].attachments.splice(toDelete[0].attachmentIndex!, 1);
              } else {
                this.updatedDocuments.splice(toDelete[0].flatDocumentIndex, 1);
              }
            }
          }
          this.documents = [...this.documents];
          this.documentsChange.emit(this.updatedDocuments);
          this.changeDetectorRef.detectChanges();
        }
      }
    });
  }

  /**
   * Displaying Toaster messages on deleting, or any error in document
   */
  showToaster() {
    this.subscription.add(
      this.store.select(getDeletedStatus).subscribe((isDeleted) => {
        if (isDeleted) {
          this.helperService.showSuccessToastr(
            this.translateService.instant('Your record has been deleted.')
          );
          this.store.dispatch(DocumentActions.resetDeleteStatus());
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSearch(event: { filter: filterKeys }) {
    this.filters = event.filter;
    if (this.userId)
      this.store.dispatch(
        DocumentActions.loadDocuments({
          search: this.searchText,
          user_id: this.userId!,
          ...this.filters,
        })
      );
    else {
      this.documents = this.records.filter((doc) =>
        Object.entries(this.filters).every(([key, value]) => {
          return String(doc[key as keyof DocumentItem])
            .toLowerCase()
            .includes(String(value).toLowerCase());
        })
      );
    }
  }

  download(document: DocumentItem) {
    if (
      this.userId &&
      document.attachment &&
      typeof document.attachment === 'string'
    ) {
      this.helperService.downloadImageWithFileSaver(
        environment.employee_attachment_url(document.attachment),
        document.file_name
      );
    } else {
      saveAs(document.attachment, document.file_name);
    }
  }
  convertPayloadintoDocumentItem(
    payload: AddDocumentPayload[]
  ): DocumentItem[] {
    const data = payload.flatMap((obj, i) =>
      [...obj.attachments].map((it, index) => ({
        ...obj,
        attachments: [it],
        attachmentIndex: index,
        flatDocumentIndex: i,
      }))
    );
    return data.map((doc) => {
      return {
        id: 0,
        document_id: `${doc.document_type_id}`,
        module_id: '0',
        name: doc.custom_name
          ? doc.custom_name
          : this.documentTypes.find((type) => type.id === doc.document_type_id)
              ?.name || '',
        file_name: doc.attachments[0].name,
        attachment: doc.attachments[0],
        file_extension: doc.attachments[0].name.split('.').pop() || '',
        created_by: 0,
        updated_by: 0,
        module_type: 0,
        updated_at: new Date(),
        created_at: new Date(),
        document_type_name:
          this.documentTypes.find((type) => type.id === doc.document_type_id)
            ?.name || '',
        attachmentIndex: doc.attachmentIndex,
        flatDocumentIndex: doc.flatDocumentIndex,
        created_date_str:
          this.datepipe.transform(new Date(), 'dd-MM-YYYY HH:ss:SS') ?? '',
        employee_name: '',
        expiry_date: doc.expiry_date ? doc.expiry_date : new Date(),
        expiry_date_str: doc.expiry_date
          ? this.datepipe.transform(new Date(doc.expiry_date), 'dd-MM-YYYY') ||
            ''
          : this.datepipe.transform(new Date(), 'dd-MM-YYYY') || '',
      };
    });
  }

  editDocument(result: AddDocumentPayload) {
    if (this.userId) {
      this.loaderService.showLoader();
      this.subscription.add(
        this.employeeService.editDocument(result).subscribe(
          (res) => {
            this.documentUpdated.emit(true);
            this.loaderService.hideLoader();

            if (res.success) {
              this.helperService.showSuccessToastr(res.message);
              this.store.dispatch(DocumentActions.updateDocumentSuccess(res));
            }
          },
          (error) => {
            this.loaderService.hideLoader();
          }
        )
      );
    } else {
      if (
        this.updatedDocuments[result.flatDocumentIndex!].attachments.length == 1
      ) {
        this.updatedDocuments[result.flatDocumentIndex!] = result;
      } else {
        this.updatedDocuments[result.flatDocumentIndex!].attachments.splice(
          result.attachmentIndex!,
          1
        );
        // if (typeof result.attachmentIndex !== 'undefined')
        this.updatedDocuments.splice(0, 0, result);
        // this.updatedDocuments = [...this.updatedDocuments, result];
      }
      this.documentsChange.emit(this.updatedDocuments);
      const documents = this.convertPayloadintoDocumentItem([
        ...this.updatedDocuments,
      ]);
      this.records = [...documents];
      this.documents = [...documents];
    }
  }

  addDocument(result: any) {
    if (this.userId) {
      this.loaderService.showLoader();
      this.subscription.add(
        this.employeeService.addDocument(result).subscribe(
          (res) => {
            this.documentUpdated.emit(true);
            this.loaderService.hideLoader();

            if (res.success) {
              this.helperService.showSuccessToastr(res.message);
              this.store.dispatch(DocumentActions.addDocumentSuccess(res));
            }
          },
          (error) => {
            this.loaderService.hideLoader();
          }
        )
      );
    } else {
      this.updatedDocuments = [...this.updatedDocuments, result];
      this.documentsChange.emit(this.updatedDocuments);

      const documents = this.convertPayloadintoDocumentItem([
        ...this.updatedDocuments,
      ]);
      this.records = [...documents];
      this.documents = [...documents];
    }
  }
}
